export class LoadTemplates {
    public static readonly type = '[DataCollection] Load templates';
}
